import{B as z}from"./chunk-BaseElement-COVKFV2h.js";import{C as j}from"./chunk-constructorio-DDhIvy8f.js";import{x as d,T as f}from"./chunk-lit-element-CULRVKo8.js";import{c as $}from"./chunk-repeat-CLr2jifB.js";import{t as E}from"./chunk-custom-element-BhZVzxrc.js";import{n as m}from"./chunk-property-BXqvfTtY.js";import"./chunk-_commonjsHelpers-Cpj98o6Y.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var O=Object.defineProperty,L=Object.getOwnPropertyDescriptor,h=(t,e,l,s)=>{for(var r=s>1?void 0:s?L(e,l):e,a=t.length-1,i;a>=0;a--)(i=t[a])&&(r=(s?i(e,l,r):i(r))||r);return s&&r&&O(e,l,r),r};let g=class extends z{constructor(){super(...arguments),this.textSort="",this.textFilter="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.type="",this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.resultsPerPage=16,this.resourcesData={},this._constructorResponseID=0}connectedCallback(){super.connectedCallback(),this.constructorio=new j({apiKey:window.__VENDORS__.constructor.apiKey,eventDispatcher:{waitForBeacon:!1}}),this.constructorio.tracker.on("error",t=>{console.log("Tracker error ",JSON.stringify(t))}),this.fetchAllResources()}async fetchAllResources(){try{const t=await this.getPaginatedResults();if(t){const{results:e,totalPages:l,facets:s,sortOptions:r,totalResults:a}=t;if(!e)return;const i=e.length>0?e.map(n=>{var o,u,y;return{handle:(o=n.data)==null?void 0:o.handle,type:((u=n.data)==null?void 0:u.type)??"",id:((y=n.data)==null?void 0:y.id)??""}}):[];this.resourcesData={sortOptions:r,facets:s,cards:i,paginationIds:Array.from({length:l},(n,o)=>o+1),totalResults:a}}}catch(t){console.error("Error fetching browse results:",t)}}async getPaginatedResults(t=1,e=16,l={},s=""){var r,a,i,n;try{const o=await this.constructorio.browse.getBrowseResults("type",this.type,{section:"Articles",resultsPerPage:e,page:t,filters:l,sortBy:s,sortOrder:s.includes("ascending")?"ascending":"descending"}),u=(r=o==null?void 0:o.response)==null?void 0:r.results,y=(a=o==null?void 0:o.response)==null?void 0:a.total_num_results,v=Math.ceil((y??1)/this.resultsPerPage),w=(i=o==null?void 0:o.response)==null?void 0:i.facets,c=(n=o==null?void 0:o.response)==null?void 0:n.sort_options;return{results:u,totalPages:v,currentPage:t,facets:w,sortOptions:c,totalResults:y}}catch(o){return console.error("Constructor.io pagination error:",o),null}}async filterChanged(t,e){var w;if(!t)return;const l=e==null?void 0:e.hasAttribute("target-mobile-clear-all");if(e)if(e.id.toLowerCase().includes("mobile")){if(e.getAttribute("type")==="radio"){const c=document.querySelector('select[name="sort_by"]');c&&(c.value=e.value,c.dispatchEvent(new Event("change",{bubbles:!0})))}else{const c=e.id.replace("Mobile","Desktop"),b=document.getElementById(c);b&&(b.checked=e.checked,b.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(e.tagName.toLowerCase()==="select"){const c=document.querySelector(`[type="radio"][name="sort_by"][value="${e.value}"]`);c.checked=!0}else{const c=document.getElementById(e.id.replace("Desktop","Mobile"));c&&(e.type=="checkbox"?c.checked=e.checked:c.value=e.value)}const s=(w=t.querySelector("#SortOptionsFormDesktop select"))==null?void 0:w.value;let r=1;const a=t.querySelector("[aria-current='page']");a&&!e&&a.textContent&&(r=parseFloat(a.textContent));const i=parseFloat(t.getAttribute("data-pagination-results-per-page")),n=t.querySelector("[target-filters]"),o=new FormData(n),u={};for(const[c,b]of o.entries())u[c]?Array.isArray(u[c])?u[c].push(b):u[c]=[u[c],b]:u[c]=b;const y={};if(!l)for(const[c,b]of Object.entries(u))c!=="sort_by"&&(y[c]=b);this.scrollIntoView();const v=await this.getPaginatedResults(r,i,y,s);if(this._constructorResponseID++,v){const{results:c,totalPages:b,facets:k,sortOptions:R,totalResults:M}=v,C=c&&c.length>0?c.map(p=>{var x,_,S,A,F,D;return(x=p.data)!=null&&x.handle&&((_=p.data)!=null&&_.type)&&((S=p.data)!=null&&S.id)?{handle:(A=p.data)==null?void 0:A.handle,type:(F=p.data)==null?void 0:F.type,id:(D=p.data)==null?void 0:D.id}:{}}):[];if(!C)return;const P=(k==null?void 0:k.filter(p=>(p==null?void 0:p.type)==="multiple").map(p=>({...p,opened:Array.isArray(p.options)&&p.options.some(x=>x.status!=="")})))??[];this.resourcesData={sortOptions:R,cards:C,facets:P,paginationIds:Array.from({length:b},(p,x)=>x+1),totalResults:M},this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(t){var r,a;const e=t.target,l=(a=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:a.querySelectorAll("button:not([data-direction])"),s=parseInt(e==null?void 0:e.textContent);this.currentPage=s,l==null||l.forEach(i=>{var u;const o=parseInt((u=i.querySelector("span"))==null?void 0:u.textContent)==s;i.classList.toggle("border-t-foreground",o),i.classList.toggle("border-t-border",!o),o?(i.setAttribute("aria-current","page"),this.filterChanged(e.closest("search-results-section"))):i.removeAttribute("aria-current")})}paginateArrowClick(t){var r,a,i,n;const e=t.target,l=(a=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:a.querySelector("[aria-current='page']"),s=(n=(i=e.parentElement)==null?void 0:i.parentElement)==null?void 0:n.querySelectorAll("button:not([data-direction])");if(l&&s&&e){const o=Array.from(s).indexOf(l),u=parseFloat(e==null?void 0:e.getAttribute("data-direction"));u>0&&o<s.length-1&&s[o+1].click(),u<0&&o>0&&s[o-1].click()}}applyFilterEvent(t){const e=t.target;this.currentPage=1,this.filterChanged(e.closest("search-results-section"),e)}clearAllFiltersMobile(t){t.preventDefault(),this.applyFilterEvent(t)}handleSelectChange(t){this.applyFilterEvent(t)}handleCheckboxChange(t){this.applyFilterEvent(t)}handleize(t){return t.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getFacetsHTML(t,e,l){var r;const s=t==null?void 0:t.reduce((a,i)=>{const n=i.type!="range"?i.options.filter(o=>o.status==="selected").length:Object.hasOwn(i.status,"min")&&Object.hasOwn(i.status,"max")&&(i.status.min!=i.min||i.status.max!=i.max)?1:0;return a+n},0);return d`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${e=="Mobile"?" overflow-auto":f}"
        >
          ${$(t??[],a=>a.name+e+this._constructorResponseID,a=>{var i;return d` ${((i=a.display_name)==null?void 0:i.toLowerCase())!="type"?d` <details
                    class="group/details border-b border-t-border"
                    ?open="${e!="Mobile"||a.opened}"
                  >
                    <summary
                      class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                    >
                      <div
                        class="flex w-full items-center justify-between text-sm"
                      >
                        <span
                          class="${window.brand=="NG"?"text-t-foreground-secondary":""} text-heading-6 font-medium capitalize"
                          >${a.display_name}</span
                        >
                        <span class="hidden group-open/details:block">
                          <svg-icon
                            src="icon-minus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                        <span class="block group-open/details:hidden">
                          <svg-icon
                            src="icon-plus"
                            class="block md:hidden"
                            style="--icon-size: 13px;"
                          ></svg-icon>
                        </span>
                      </div>
                    </summary>
                    ${d`
                      ${a.type==="multiple"?d`
                            <div
                              class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                            >
                              <ul class="list-unstyled space-y-2xs" role="list">
                                ${$(a.options,n=>n.value,(n,o)=>d` ${n.display_name!=""?d` <li
                                          class=${o>=this.facetsCheckboxVisibleLimit?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                        >
                                          <div
                                            class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                          >
                                            <label
                                              class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                              for="Filter-filter.p.${this.handleize(n.display_name)}-${e}-${o}"
                                            >
                                              <input
                                                type="checkbox"
                                                class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                                id="Filter-filter.p.${this.handleize(n.display_name)}-${e}-${o}"
                                                value="${n.value}"
                                                name="${a.name}"
                                                aria-labelledby="Filter-filter.p.${this.handleize(n.display_name)}-${e}-${o}_label"
                                                .checked=${n.status!==""}
                                                @change=${this.handleCheckboxChange}
                                              />
                                              <span
                                                class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                              >
                                                <svg-icon
                                                  src="icon-checkbox-tick"
                                                  class="block"
                                                  style="--icon-size: 12px;"
                                                ></svg-icon>
                                              </span>
                                            </label>
                                            <label
                                              class="text-body mt-px cursor-pointer select-none break-all capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                              for="Filter-filter.p.${this.handleize(n.display_name)}-${e}-${o}"
                                            >
                                              ${n.display_name}
                                            </label>
                                          </div>
                                        </li>`:f}`)}
                              </ul>
                              ${a.options.length>this.facetsCheckboxVisibleLimit?d`
                                    <toggle-button
                                      role="button"
                                      data-toggled="false"
                                      class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                    >
                                      <span
                                        class='group-data-[toggled="true"]/toggle-button:hidden'
                                        >${this.textViewAllCount.replace("{{ count }}",`${a.options.length}`)}</span
                                      >
                                      <span
                                        class='group-data-[toggled="false"]/toggle-button:hidden'
                                        >${this.textHideCount.replace("{{ count }}",`${a.options.length-this.facetsCheckboxVisibleLimit}`)}</span
                                      >
                                    </toggle-button>
                                  `:f}
                            </div>
                          `:f}
                    `}
                  </details>`:f}`})}
        </div>
        ${e=="Mobile"?d`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(s??0)>0}
              >
                <dialog-toggle modal-id="${l}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${((r=this.textApply)==null?void 0:r.replace("{{ count }}",(s==null?void 0:s.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-mobile-clear-all
                  @click=${this.clearAllFiltersMobile}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:f}
      </div>
    `}getSortHTML(t,e){return d`
      ${e=="Desktop"?d` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${e}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  aria-describedby="a11y-refresh-page-message"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${$(t??[],l=>l.sort_by+e,l=>{var s;return d`
                      <option
                        value="${l.sort_by}"
                        ${l.status!=""?' selected="selected"':""}
                      >
                        ${(s=l.display_name)==null?void 0:s.replace("Most Relevant","Featured")}
                      </option>
                    `})}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:d` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${e}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${e}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${e}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${$(t??[],l=>l.sort_by+e,l=>d`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio inline-flex items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${e}_input_${l.sort_by}"
                              name="sort_by"
                              value="${l.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${l.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px cursor-pointer select-none"
                            for="sortoptionsform${e}_input_new-arrivals8"
                          >
                            <div>
                              <p
                                id="sortoptionsform${e}_input_new-arrivals8_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${l.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(t,e){const s=[];if(s.push("1"),e<=6)for(let r=2;r<e;r++)s.push(r);else if(t<=3){for(let r=2;r<=4;r++)s.push(r);s.push("...")}else if(t>=e-2){s.push("...");for(let r=e-3;r<e;r++)s.push(r)}else s.push("..."),s.push(t-1),s.push(t),s.push(t+1),s.push("...");return s[s.length-1]!==e&&s.push(e),s.map(r=>r.toString())}getPaginateHTML(t,e=1){if(!t)return;const l=this.getPaginationArray(e,t.length);if(l)return d`
      ${(t==null?void 0:t.length)>1?d`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(t==null?void 0:t.length)>1?d`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${e===1}
                          aria-disabled="${e===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: 90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:f}
                ${$(l,s=>"productPage"+s,s=>d`
                    ${s!="..."?d`
                          <li class="inline-flex list-none">
                            <button
                              class="${s==e.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${s==e.toString()?"page":f}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${s}</span
                              >
                            </button>
                          </li>
                        `:d`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(t==null?void 0:t.length)>1?d`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===t.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${e===t.length}
                          aria-disabled="${e===t.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src="icon-caret"
                            class="pointer-events-none block"
                            style="--icon-size: 16px; rotate: -90deg;"
                          ></svg-icon>
                        </button>
                      </li>
                    `:f}
              </ul>
            </div>
          `:f}
    `}getModalDialog(t,e,l,s,r,a,i,n,o){return d`
      <modal-dialog
        cloak
        type="${r}"
        id="${t}"
        anchor="${e}"
        close-on-backdrop-click="true"
        drawer-classes="${o}"
        close-icon-size="${i}"
      >
        <h5 slot="header" class="${n} h6">${a}</h5>
        <div slot="additional-content">${s}</div>
        <form target-filters is-mobile class="h-full">${l}</form>
      </modal-dialog>
    `}render(){var t,e,l,s,r,a,i,n,o;return d` <search-results-section
      class="grid grid-cols-1 pb-sm 2xl:container md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs md:px-pagemargin"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="type"
      data-cnstrc-filter-value="${this.type}"
      data-cnstrc-num-results="${((t=this.resourcesData)==null?void 0:t.totalResults)??0}"
    >
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML((e=this.resourcesData)==null?void 0:e.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML((l=this.resourcesData)==null?void 0:l.facets,"Mobile","filter-drawer-dialog-content"),"","drawer",this.textFilter,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((s=this.resourcesData)==null?void 0:s.sortOptions,"Mobile"),"","drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div class="flex">
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((r=this.resourcesData)==null?void 0:r.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
                >${(a=this.resourcesData)!=null&&a.totalResults?(((i=this.resourcesData)==null?void 0:i.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(n=this.resourcesData)==null?void 0:n.totalResults}`):f}</span
              >
            </div>
            <div>
              <div
                class="grid gap-y-xs max-md:px-pagegridmargin md:grid-cols-2 md:gap-x-xs md:gap-y-md lg:grid-cols-4 lg:gap-y-7"
              >
                ${$(((o=this.resourcesData)==null?void 0:o.cards)??[],u=>u.id,u=>d`
                    <dynamic-card
                      handle="${u.handle}"
                      view="article-card"
                      query-type="article"
                      article-type="${this.type}"
                    >
                    </dynamic-card>
                  `)}
              </div>
            </div>
            ${this.getPaginateHTML(this.resourcesData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </search-results-section>`}};h([m({type:String,attribute:"data-sort"})],g.prototype,"textSort",2);h([m({type:String,attribute:"data-filter"})],g.prototype,"textFilter",2);h([m({type:String,attribute:"data-hide-count"})],g.prototype,"textHideCount",2);h([m({type:String,attribute:"data-view-all-count"})],g.prototype,"textViewAllCount",2);h([m({type:String,attribute:"data-apply"})],g.prototype,"textApply",2);h([m({type:String,attribute:"data-clear-all"})],g.prototype,"textClearAll",2);h([m({type:String,attribute:"data-results-grid-with-count-one"})],g.prototype,"dataResultsGridWithCountOne",2);h([m({type:String,attribute:"data-results-grid-with-count-other"})],g.prototype,"dataResultsGridWithCountOther",2);h([m({type:String})],g.prototype,"type",2);h([m({type:Number})],g.prototype,"facetsCheckboxVisibleLimit",2);h([m({type:Number})],g.prototype,"currentPage",2);h([m({type:Number,attribute:"results-per-page"})],g.prototype,"resultsPerPage",2);h([m({type:Object})],g.prototype,"resourcesData",2);g=h([E("resource-results")],g);
